import React from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ site, onConfirm, onCancel }) => {
  if (!site) {
    return null;
  }

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <div className="delete-modal-header">
          <div className="delete-modal-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2>Delete Site</h2>
        </div>
        
        <div className="delete-modal-body">
          <p className="delete-modal-warning">
            Are you sure you want to delete <strong>"{site?.name}"</strong>?
          </p>
          <div className="delete-modal-danger">
            <p>
              <strong>This action cannot be undone.</strong> All of the following data will be permanently deleted:
            </p>
            <ul>
              <li>All analytics data (page views, sessions, users, etc.)</li>
              <li>All device and channel breakdown data</li>
              <li>All insights and recommendations</li>
              <li>All AdSense connection data</li>
              <li>All sync logs</li>
            </ul>
          </div>
        </div>

        <div className="delete-modal-actions">
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn-delete" onClick={onConfirm}>
            Yes, Delete Site
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;

